import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { GetApp } from '@mui/icons-material';
import { getLoiByTransactionId } from 'services/network/api/payment';
import styles from './DashboardWalletSocietyDocument.module.css';
export default function DashboardWalletSocietyDocument({ societyId, idTransaction, iss }) {
    const [status, setStatus] = useState('IDLE');
    const [documents, setDocuments] = useState([]);
    const { t } = useTranslation();
    useEffect(() => {
        const getDocuments = async () => {
            setStatus('LOADING');
            const response = await Promise.all(idTransaction.map((id) => getLoiByTransactionId(id)));
            if (response) {
                const successfulResponses = response.filter((res) => (res === null || res === void 0 ? void 0 : res.status) === 200);
                setDocuments(successfulResponses.map((res) => (Object.assign(Object.assign({}, ((res === null || res === void 0 ? void 0 : res.data) || {})), { title: res === null || res === void 0 ? void 0 : res.data.name, date: res === null || res === void 0 ? void 0 : res.data.updated }))));
                setStatus('SUCCESS');
            }
            else {
                setStatus('FAIL');
                setDocuments([]);
            }
        };
        if (status === 'IDLE') {
            getDocuments();
        }
    }, [status, idTransaction]);
    const getDocumentLink = ({ url }) => `${url}?refresh_token=${window.localStorage.getItem('auth_refresh')}`;
    if (status !== 'SUCCESS')
        return null;
    return (_jsxs("section", { className: styles.documents, children: [_jsx("h3", { className: styles.title, children: t('dashboard.wallet.documents.title') }), documents === null || documents === void 0 ? void 0 : documents.map((document) => (_jsxs("div", { className: styles.document, children: [_jsxs("div", { children: [_jsx("p", { className: styles.title, children: document.title }), _jsx("p", { className: styles.date, children: document.date })] }), _jsx("a", { href: getDocumentLink(document), "aria-label": "Download", download: document.title, target: "_blank", rel: "noreferrer", className: styles.download, children: _jsx(GetApp, {}) })] }, document.id)))] }));
}
